import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import './MediaCenterPage.css';

const MediaCenterPage = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const newsArticles = [
    {
      id: 1,
      date: language === 'ar' ? '18 مايو 2026' : 'May 18, 2026',
      title: language === 'ar' 
        ? 'يوم علاجي مجاني بمنطقة كعكول بمحلية كوستي شراكة بين منظمة المندولة ووزارة الصحة بالنيل الأبيض'
        : 'Free Medical Day in Kakoul Area, Kosti Locality - Partnership between Al-Mandola Organization and White Nile State Ministry of Health',
      content: language === 'ar'
        ? `كوستي /اعلام الوالي الاثنين 18مايو 2026 م
متابعة :- بخيت بقادي

في إطار الشراكة الذكية بين منظمة المندولة للإغاثة والإعمار فرعية النيل الأبيض ووزارة الصحة بالولاية، نُظم يوم علاجي مجاني بمنطقة كعكول بمحلية كوستي تحت شعار معاً نحو مجتمع أكثر صحة وعافية.

وشهد البرنامج إقبالاً واسعاً من الأهالي، حيث قُدمت حزمة متكاملة من الخدمات الطبية شملت مقابلة الأطباء و التشخيص العام الي جانب إجراء الفحوصات المعملية عبر مختبرات مجهزة وصرف الأدوية والعقاقير الطبية مجاناً.

كما صاحب اليوم العلاجي محاضرات توعوية وإرشادية حول الوقاية من الأمراض وتعزيز الرعاية الصحية الأولية داخل الأسرة.

وقد أعرب مواطنو المنطقة عن تقديرهم لهذه المبادرة التي أسهمت في تلبية احتياجات صحية عاجلة، مؤكدين أهمية استمرار مثل هذه القوافل الطبية لدعم استقرار المجتمعات الريفية والحضرية.

يُذكر أن هذا البرنامج هو الأول من نوعه للمنظمة في ولاية النيل الأبيض، حيث وعدت إدارتها بتنظيم المزيد من الأيام العلاجية والصحية في مختلف المحليات دعماً للمواطنين وتوطين للعلاج داخل هذه المجتمعات.`
        : `Kosti / Governor's Media - Monday, May 18, 2026
Follow-up: Bakheet Baqadi

As part of the smart partnership between Al-Mandola Relief and Reconstruction Organization, White Nile Branch, and the State Ministry of Health, a free medical day was organized in the Kakoul area of Kosti locality under the slogan "Together Towards a Healthier Community."

The program witnessed wide participation from residents, where a comprehensive package of medical services was provided, including doctor consultations, general diagnosis, laboratory tests through equipped laboratories, and free distribution of medicines and medical drugs.

The medical day was accompanied by awareness and guidance lectures on disease prevention and promoting primary health care within the family.

The residents of the area expressed their appreciation for this initiative, which contributed to meeting urgent health needs, emphasizing the importance of continuing such medical caravans to support the stability of rural and urban communities.

It is worth noting that this program is the first of its kind for the organization in White Nile State, where its management promised to organize more medical and health days in various localities to support citizens and localize treatment within these communities.`,
      images: [
        '/MRRO/medical-day/main.jpeg',
        '/MRRO/medical-day/main2.jpeg',
        '/MRRO/medical-day/main3.jpeg'
      ]
    },
    {
      id: 2,
      date: language === 'ar' ? 'مايو 2026' : 'May 2026',
      title: language === 'ar'
        ? 'تقرير عن حملة النظافة في معسكر الكرامة (3)'
        : 'Report on the Cleanliness Campaign at Al-Karama Camp (3)',
      content: language === 'ar'
        ? `المقدمة

في إطار تعزيز الصحة العامة والحفاظ على البيئة داخل المعسكرات، نظمت منظمة المندولة للإغاثة والإعمار بالتعاون مع وزارة الصحة بإقليم النيل الأزرق حملة نظافة شاملة في معسكر الكرامة (3). هدفت الحملة إلى تحسين البيئة الصحية، والحد من انتشار الأمراض والأوبئة، ورفع الوعي لدى سكان المعسكر بأهمية النظافة العامة.

أهداف الحملة

تعزيز الوعي الصحي والبيئي داخل المجتمع، إزالة النفايات والقمامة من داخل المعسكر ومحيطه، الحد من انتشار الأمراض المرتبطة بتراكم النفايات، تشجيع المشاركة المجتمعية والعمل التطوعي، وخلق بيئة صحية وآمنة لسكان المعسكر.

الأنشطة المنفذة

خلال الحملة، تم تنفيذ عدة أنشطة مهمة، منها: تنظيف الساحات العامة والممرات الداخلية، جمع النفايات والقمامة والتخلص منها، تنظيف المناطق ذات المياه الراكدة، التوعية بالنظافة الشخصية والعامة، توزيع أدوات ومستلزمات النظافة على الفرق المشاركة، وتشجيع مشاركة المتطوعين والشباب والنساء في أنشطة التنظيف.

الجهات المشاركة

ساهمت عدة جهات في نجاح الحملة، أبرزها: منظمة المندولة للإغاثة والإعمار، وزارة الصحة – إقليم النيل الأزرق، لجان المعسكر، المتطوعون ومجموعات الشباب، والقيادات المجتمعية داخل المعسكر.

نتائج الحملة

حققت الحملة عدة نتائج إيجابية، منها: تحسين مستوى النظافة داخل المعسكر، زيادة الوعي الصحي لدى السكان، تعزيز روح التعاون والعمل الجماعي، الحد من المخاطر الصحية الناجمة عن تراكم النفايات، وتشجيع المجتمع على الحفاظ على بيئة نظيفة.

التوصيات

إجراء حملات نظافة دورية داخل المعسكر، توفير حاويات النفايات ومعدات التنظيف بشكل مستمر، تكثيف برامج التوعية الصحية والبيئية، دعم مبادرات الشباب والمتطوعين، وتعزيز التعاون بين المنظمات والمؤسسات الحكومية.

الخاتمة

تمثل حملة النظافة في معسكر الكرامة (3) خطوة مهمة نحو تحسين البيئة الصحية وتعزيز الوعي المجتمعي بأهمية النظافة. كما تعكس روح التعاون بين المؤسسات الرسمية والمنظمات الإنسانية وأفراد المجتمع، مما يسهم في خلق بيئة أكثر صحة وأماناً.`
        : `Introduction

As part of promoting public health and preserving the environment within the camps, Al-Mandoula Organization for Relief and Reconstruction, in cooperation with the Ministry of Health in the Blue Nile Region, organized a comprehensive cleanliness campaign at Al-Karama Camp (3). The campaign aimed to improve the health environment, reduce the spread of diseases and epidemics, and raise awareness among camp residents about the importance of public cleanliness.

Objectives of the Campaign

Promote health and environmental awareness within the community, remove waste and garbage from inside and around the camp, reduce the spread of diseases associated with waste accumulation, encourage community participation and volunteer work, and create a healthy and safe environment for camp residents.

Implemented Activities

During the campaign, several important activities were carried out, including: cleaning public squares and internal pathways, collecting and disposing of waste and garbage, cleaning areas with stagnant water, raising awareness about personal and public hygiene, distributing cleaning tools and supplies to participating teams, and encouraging the participation of volunteers, youth, and women in cleaning activities.

Participating Entities

Several parties contributed to the success of the campaign, most notably: Al-Mandoula Organization for Relief and Reconstruction, Ministry of Health – Blue Nile Region, camp committees, volunteers and youth groups, and community leaders within the camp.

Results of the Campaign

The campaign achieved several positive outcomes, including: improving the level of cleanliness within the camp, increasing health awareness among residents, strengthening the spirit of cooperation and teamwork, reducing health risks caused by accumulated waste, and encouraging the community to maintain a clean environment.

Recommendations

Conduct regular cleanliness campaigns within the camp, provide waste containers and cleaning equipment on a continuous basis, intensify health and environmental awareness programs, support youth and volunteer initiatives, and strengthen cooperation between organizations and government institutions.

Conclusion

The cleanliness campaign at Al-Karama Camp (3) represents an important step toward improving the health environment and enhancing community awareness about the importance of cleanliness. It also reflects the spirit of cooperation between official institutions, humanitarian organizations, and community members, contributing to a healthier and safer environment.`,
      images: [
        '/cleaning/1.jpeg',
        '/cleaning/2.jpeg'
      ]
    }
  ];

  const annualReports = [
    // Annual reports will be added here
  ];

  const mediaGallery = [
    {
      title: language === 'ar' ? 'مشروع المياه - بورتسودان' : 'Water Project - Port Sudan',
      images: [
        '/MRRO/Media/portsudan/2.jpg',
        '/MRRO/Media/portsudan/4.jpg',
        '/MRRO/Media/portsudan/6.jpg',
        '/MRRO/Media/portsudan/7.jpg',
        '/MRRO/Media/portsudan/10.jpg',
        '/MRRO/Media/portsudan/11.jpg',
        '/MRRO/Media/portsudan/12.jpg',
        '/MRRO/Media/portsudan/13.jpg',
        '/MRRO/Media/portsudan/14.jpg'
      ]
    },
    {
      title: language === 'ar' ? 'مشروع المياه الطارئ - تاويلا' : 'Emergency Water Project - Tawila',
      images: [
        '/MRRO/Media/taweela/1.jpg',
        '/MRRO/Media/taweela/5.jpg',
        '/MRRO/Media/taweela/9.jpg'
      ]
    },
    {
      title: language === 'ar' ? 'مبادرة فرحة العيد' : 'Eid Joy Initiative',
      images: [
        '/joy-eid/1.jpeg',
        '/joy-eid/2.jpeg',
        '/joy-eid/3.jpeg',
        '/joy-eid/4.jpeg',
        '/joy-eid/5.jpeg',
        '/joy-eid/6.jpeg',
        '/joy-eid/7.jpeg'
      ]
    },
    {
      title: language === 'ar' ? 'اليوم العلاجي المجاني - كعكول' : 'Free Medical Day - Kakoul',
      images: [
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.04.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.05.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.06.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.07.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.08.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.09.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.10.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.11.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.12.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.13.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.14.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.15.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.16.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.17.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.18.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.19.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.20.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.21.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.22.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.23.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.24.jpeg',
        '/MRRO/medical-day/WhatsApp Image 2569-05-25 at 15.48.25.jpeg'
      ]
    },
    {
      title: language === 'ar' ? 'حملة النظافة - معسكر الكرامة (3)' : 'Cleanliness Campaign - Al-Karama Camp (3)',
      images: [
        '/cleaning/1.jpeg',
        '/cleaning/2.jpeg',
        '/cleaning/3.jpeg',
        '/cleaning/4.jpeg'
      ]
    }
  ];

  return (
    <div className="media-center-page">
      <div className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <h1 className="page-title">
              {t.mediaCenterTitle}
            </h1>
            <p className="page-subtitle">
              {t.mediaCenterSubtitle}
            </p>
          </div>
        </div>
      </div>

      <div className="media-content">
        <div className="container">
          {/* News Section */}
          <div className="news-section">
            <h2 className="section-title">
              {language === 'ar' ? 'الأخبار' : 'News'}
            </h2>
            <div className="news-grid">
              {newsArticles.map((article) => (
                <article key={article.id} className="news-article">
                  <div className="news-date">{article.date}</div>
                  <h3 className="news-title">{article.title}</h3>
                  <div className="news-content">
                    {article.content.split('\n\n').map((paragraph, idx) => (
                      <p key={idx}>{paragraph}</p>
                    ))}
                  </div>
                  {article.images && article.images.length > 0 && (
                    <div className="news-images">
                      {article.images.map((image, imgIdx) => (
                        <div key={imgIdx} className="news-image">
                          <img src={image} alt={`${article.title} - ${imgIdx + 1}`} />
                        </div>
                      ))}
                    </div>
                  )}
                </article>
              ))}
            </div>
          </div>

          {/* Media Gallery Section */}
          <div className="gallery-section">
            <h2 className="section-title">
              {language === 'ar' ? 'معرض الصور' : 'Photo Gallery'}
            </h2>
            {mediaGallery.map((section, index) => (
              <div key={index} className="media-section">
                <h3 className="media-section-title">{section.title}</h3>
                <div className="media-grid">
                  {section.images.map((image, imgIndex) => (
                    <div key={imgIndex} className="media-item">
                      <img src={image} alt={`${section.title} - ${imgIndex + 1}`} />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Annual Reports Section */}
          <div className="annual-reports-section">
            <h2 className="section-title">
              {language === 'ar' ? 'التقارير السنوية' : 'Annual Reports'}
            </h2>
            {annualReports.length === 0 ? (
              <div className="empty-state">
                <p className="empty-message">
                  {language === 'ar' 
                    ? 'لا توجد تقارير متاحة حالياً' 
                    : 'No reports available at the moment'}
                </p>
              </div>
            ) : (
              <div className="reports-grid">
                {annualReports.map((report, index) => (
                  <div key={index} className="report-card">
                    <div className="report-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"/>
                        <path d="M14 2v6h6"/>
                      </svg>
                    </div>
                    <h3 className="report-title">{report.title}</h3>
                    <p className="report-year">{report.year}</p>
                    <a href={report.file} download className="report-download-btn">
                      {language === 'ar' ? 'تحميل التقرير' : 'Download Report'}
                    </a>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaCenterPage;
